import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { NuqsAdapter } from "nuqs/adapters/react";
import { App } from "./App";
import { PerfManager, usePerfManager } from "@/features/performance";
import { LoadingManager } from "@/features/loading";

export const queryClient = new QueryClient();

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
  <StrictMode>       
        <QueryClientProvider client={queryClient}>
          <NuqsAdapter>
            <LoadingManager>
              <PerfManager>
                <App />
              </PerfManager>
            </LoadingManager>
          </NuqsAdapter>
        </QueryClientProvider>
  </StrictMode>    
  );
} else {
  throw new Error("Root element not found");
}
